export default "__VITE_ASSET__DZ9ie_FO__"